import React from "react";
import {useSelector} from "react-redux";
import styles from "../MainHeader.module.scss";
import {ReactComponent as SettingsIconThick} from "ui-components-rollup/src/images/monochrome-icons/ic-settings-thick.svg";
import {ReactComponent as SettingsIcon} from "ui-components-rollup/src/images/monochrome-icons/ic-settings.svg";
import SlidingWidget from "./SlidingWidget"
import MenuLinkItem from "./MenuLinkItem";
import _ from "lodash";

const Content = React.memo(() => {
    const activeAgent = useSelector(state => state.tenancy.selectedAgent);
    const supportServices = useSelector(state => state.currentConnector.supportServices);
    const noConnector = process.env.REACT_APP_IS_SAAS === "true" && !activeAgent;
    const allowSoftwareUpdate = supportServices && !_.get(supportServices, "setupInfo.runningInDocker", false);
    const darkSite = process.env.REACT_APP_IS_DARK === 'true';
    const installLocation = useSelector(state => state.app.instancePlacement?.installLocation?.toLowerCase());
    return <div className={styles['menu-content']}>
        <MenuLinkItem disabled={noConnector} to="/connector-settings/settings">Connector Settings</MenuLinkItem>
        <MenuLinkItem disabled={noConnector || (darkSite && installLocation==="onprem")} to="/connector-settings/credentials">Credentials</MenuLinkItem>
        <MenuLinkItem disabled={noConnector} to="/connector-settings/tools">Tools</MenuLinkItem>
        {!darkSite &&
        <MenuLinkItem disabled={!allowSoftwareUpdate} to="/connector-settings/software-update">Software
            Update</MenuLinkItem>}
        <MenuLinkItem disabled={noConnector} to="/connector-settings/certificate-setup">HTTPS Setup</MenuLinkItem>

    </div>
})

export default () => {
    const {forbidden, permissions} = useSelector(state => state.tenancy);
    const disabled = (process.env.REACT_APP_IS_SAAS !== "true" && forbidden) || !permissions.allTabsAvailable;

    return <SlidingWidget
        widgetKey="settings"
        menuTitle="Settings"
        MenuIcon={SettingsIconThick}
        triggerClassName={styles['widget-button']}
        triggerActiveClassName={[styles['widget-button-active']]}
        triggerChildren={<SettingsIcon/>}
        triggerDisabled={disabled}
    >
        <Content/>
    </SlidingWidget>
};
